// In-browser debug logger for OAuth/session/roles/API tracing.
//
// Output is gated by a flag the UI loads from the API at startup — the server's
// DEBUG env var is the single source of truth (see the API `debug` query /
// api/src/graphql/query/debugQuery.js). Until the flag is loaded, and whenever
// it is false, every helper here is a no-op, so nothing is logged in normal
// operation.
//
// A runtime override is also honored so the flag can be flipped straight from
// the browser console without reloading or redeploying:
//   window.__UID_DEBUG = true    // force logging on
//   window.__UID_DEBUG = false   // force logging off
//   delete window.__UID_DEBUG    // fall back to the server DEBUG flag
//
// This module intentionally has NO imports so it can be used from anywhere
// (appStore, webservice, auth) without creating an import cycle.

let enabled = false;

/**
 * Enable/disable debug logging. Called once at startup with the API's DEBUG
 * flag; coerced to a strict boolean so ONLY an explicit `true` enables logging.
 */
export const setDebugEnabled = (value) => {
  enabled = value === true;
};

/** Whether debug logging is currently on (a runtime override wins). */
export const isDebugEnabled = () => {
  if (
    typeof window !== 'undefined' &&
    typeof window.__UID_DEBUG !== 'undefined'
  ) {
    return window.__UID_DEBUG === true;
  }
  return enabled;
};

const PREFIX = '[uid-debug]';

/**
 * Log a debug message to the browser console when debugging is enabled.
 * @param {string} scope short tag, e.g. 'auth', 'appStore', 'roles', 'api'
 * @param {...*} args message and/or payloads
 */
export const debugLog = (scope, ...args) => {
  if (!isDebugEnabled()) {
    return;
  }
  console.debug(`${PREFIX} ${scope}`, ...args);
};

export default debugLog;
